import script from "./authError.vue?vue&type=script&setup=true&lang=js"
export * from "./authError.vue?vue&type=script&setup=true&lang=js"

import "./authError.vue?vue&type=style&index=0&id=c7724c12&lang=scss&scoped=true"

import exportComponent from "/Users/luoxuelin/Workspace/idea/wnzhfc/s-pages/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7724c12"]])

export default __exports__